/** Expanded and mini (collapsed) widths for the clipped permanent nav drawer. */
export const DRAWER_WIDTH = 245;
export const DRAWER_WIDTH_COLLAPSED = 50;

/** Matches legacy `.navigation-bar` height (`3.25rem`). */
export const APP_BAR_HEIGHT = '3.25rem';

/** CSS custom property for the fixed header stack height (banner + AppBar). */
export const FIXED_HEADER_HEIGHT_VAR = '--admin-fixed-header-height';
